import _ from 'lodash';

function Phone(data) {

    this.primaryPhoneType = null;
    this.homeNumber = null;
    this.workNumber = null;
    this.cellNumber = null;

    if (data) {
        _.extend(this, data);
    }
}

export default Phone;
